var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isNoPage)?_vm._l((_vm.contentList),function(item,index){return _c(_vm.doComponent(item),{key:index,tag:"component",attrs:{"contentNo":_vm.contentList[index].contentNo,"grpList":_vm.grpList,"depth":_vm.depth,"tabindex":_vm.tabindex}})}):_c('div',{attrs:{"id":"cont_wrap"}},[_vm._v(" "+_vm._s(_vm.$t('noInfo'))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }